/**
 * Seedable PRNG used to drive Math.random() in test mode so any RNG-based
 * behavior (particle jitter, future AI decisions, loot rolls, etc.) is
 * reproducible across runs given the same seed.
 *
 * mulberry32: small, fast, decent statistical quality for game-loop use
 * (not cryptographic). https://stackoverflow.com/a/47593316
 */
export interface RNG {
  /** Returns a float in [0, 1), matching Math.random()'s contract. */
  next(): number
}

export class SeededRNG implements RNG {
  private state: number

  constructor(seed: number) {
    // avoid a zero state, which would produce a degenerate sequence
    this.state = (seed >>> 0) || 0x9e3779b9
  }

  next(): number {
    this.state |= 0
    this.state = (this.state + 0x6d2b79f5) | 0
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
